import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { UtenteForm } from '../../../form/profili-utente/utente-form';
import { UtenteProfiloRequest } from '../../../models/dto/utente-profilo-request';
import { TemplateUtenteProfilo } from '../../../models/profili-utente/template-utente-profilo';
import { UtenteProfilo } from '../../../models/profili-utente/utente-profilo';
import { UtenteProfiloTemplate } from '../../../models/profili-utente/utente-profilo-template';
import { FormValidationService } from '../../../services/form-validation.service';

declare var closeModal: any;

@Component({
    selector: 'div [utente-update-form]',
  templateUrl: '../../../form/profili-utente/utente-form.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class UtenteUpdateComponent extends UtenteForm implements OnInit {
  utente: UtenteProfilo;
  urlUpdate: string;
  originalTemplateUtente: TemplateUtenteProfilo;
  @Input() display: boolean;
  @Output()
  onReturnUtente: EventEmitter<UtenteProfilo> = new EventEmitter<UtenteProfilo>();


  constructor( @Inject(OperationsService) operationService: OperationsService,
               @Inject(FormBuilder) campiForm: FormBuilder,
               @Inject(HelpersService) helpers: HelpersService,
               @Inject(FormValidationService) formValidationService: FormValidationService) {
    super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Modifica utente');
    this.isInserimento(false);
  }


  getRequest(request: UtenteProfiloTemplate) {
    this.operationService.updateUtenteProfilo(this.urlUpdate, new UtenteProfiloRequest(request.utente, this.originalTemplateUtente)).subscribe(response => this.datiUtenteProfilo(response));
  }

  datiUtenteProfilo(response) {
    if (response.returnCode === 'OK') {
      this.onReturnUtente.emit(this.utente);
    }
  }

  getUtente() {
    return this.utente;
  }

  inizializza(urlUpdate: string, urlGetTemplates: string, utente: UtenteProfilo, templateUtenteProfilo: TemplateUtenteProfilo) {
    this.utente = utente;
    this.originalTemplateUtente = templateUtenteProfilo;
    this.urlGetTemplates = urlGetTemplates;
    this.forceTemplate(templateUtenteProfilo);
    this.createForm();
    this.urlUpdate = urlUpdate;
  }
}
